module.exports = __webpack_public_path__ + "img/grooming3.e3ead83d.jpg";